<template>

</template>

<script>
import * as SockJS from 'sockjs-client';
import * as EventBus from '@vertx/eventbus-bridge-client.js';
import VueEventBus from '../vue-event-bus';
import { mapState, mapGetters } from 'vuex';

export default {
    name: 'vertxeventbus',
    components: {
    },
    data () {
        return {
            timerId: null,
            userMapCleanerTimer: null,
            eventBus: null,
        }
    },
    computed: {
        ...mapGetters(['loggedIn', 'storeId', 'userInfo', 'activeStoreUsersMap', 'planShiftMap', 'rosterFromTo', 'employeePreferenceMap', 'actualShiftMap', 'actualBreakMap', 'rosterView']),
        userFullname(){
            if(this.userInfo.firstname && this.userInfo.lastname){
                return this.userInfo.firstname + ' ' + this.userInfo.lastname
            } else {
                return 'User';
            } 
        },
        imgUrl(){
            return this.userInfo.image_url ? this.userInfo.image_url : "";
        }
    },
    watch: {
        storeId(newVal, oldVal) {
            //clear the activeStoreUserMap
            this.$store.commit("setActiveStoreUsersMap", {activeStoreUsersMap: {}});
            if(this.eventBus != null){
                this.eventBus.close();
                this.setupEventBus();
            }
        },
    },
    created: function () {
        this.setupEventBus();
        this.cleanActiveStoreUsersMap();
        VueEventBus.$on("send-chatmessage", this.sendChatMessage);
    },
    mounted: function() { 
    },
    beforeDestroy() {
        if(this.eventBus != null){
            console.log("closing eventbus bridge");
            this.eventBus.close();
        }
        if(this.timerId){
            window.clearTimeout(this.timerId);
        }
        if(this.userMapCleanerTimer){
            window.clearTimeout(this.userMapCleanerTimer);
        }
        VueEventBus.$off("send-chatmessage", this.sendChatMessage);
    },
  methods: {
   
    setupEventBus : function (id, shareKey) {
        if(this.loggedIn){
            let view = this;
            let options = {
                vertxbus_reconnect_attempts_max: Infinity, // Max reconnect attempts
                vertxbus_reconnect_delay_min: 5000, // Initial delay (in ms) before first reconnect attempt
                vertxbus_reconnect_delay_max: 300000, // Max delay (in ms) between reconnect attempts
                vertxbus_reconnect_exponent: 2, // Exponential backoff factor
                vertxbus_randomization_factor: 0.5 // Randomization factor between 0 and 1
            };
            this.eventBus = new EventBus('/eventbus', options);
            this.eventBus.enableReconnect(true);
			this.eventBus.onclose = function (e) {
				console.log("eventbus closed");
                console.log(e);
			};
			this.eventBus.onopen = function() {
                console.log("eventbus opened");
                let token = view.$store.state.jwt;
                let storeId = Number(view.$store.state.storeId);
                let headers = { token: token, storeId: storeId};
                let rosterResultAddress = 'out-rr:'+storeId;
                let storeEventAddress = 'ebout-storeevent:'+storeId;
                let rosterEntityAddress = 'ebout-rosterentity:'+storeId;
				view.eventBus.send('sockjsauth', '', headers,  function(error, message){
                    
                    if(message != null && message.body != null){
                       if(message.body === 'OK'){
                           if(view.timerId){
                               window.clearTimeout(view.timerId);
                           }
                           view.eventBus.unregisterHandler(rosterResultAddress);
                           view.eventBus.unregisterHandler(storeEventAddress);
                           view.eventBus.unregisterHandler(rosterEntityAddress);
                           view.eventBus.registerHandler(rosterResultAddress, headers, view.eventBusRosterResultCallback);
                           view.eventBus.registerHandler(storeEventAddress, headers, view.eventBusStoreEventCallback);
                           view.eventBus.registerHandler(rosterEntityAddress, headers, view.eventBusRosterEntityCallback);
                           view.pingUserInfo();
                       } else {
                           console.log(JSON.stringify(message));
                       }
                        
                    } else if(error != null){
                        console.log(JSON.stringify(error));
                    }
			
                });
			}
			this.eventBus.onerror = function (error) {
				console.log("Problem calling event bus " + JSON.stringify(error))
			};
        }	 
    },
    eventBusRosterResultCallback: function(error, message) {
        if(message != null && message.body != null){
            let rosterResult = message.body;
            VueEventBus.$emit("rosterResult-ready", rosterResult);
                        
        } else if(error != null){
            console.log(JSON.stringify(error));
        }
    },
    eventBusStoreEventCallback: function(error, message) {
        if(message != null && message.body != null){
            let storeEvent = message.body;
            if(storeEvent.type == "userping"){
                let entry = {id: storeEvent.id, date: storeEvent.date, name: storeEvent.name, imgUrl: storeEvent.imgUrl};
                this.$store.commit("setActiveStoreUsersMapEntry", entry);
            }
            if(storeEvent.type == "chatmessage"){
                VueEventBus.$emit("chatmessage-received", storeEvent);
            }             
        } else if(error != null){
            console.log(JSON.stringify(error));
        }
    },
    eventBusRosterEntityCallback: function(error, message) {
        if(message != null && message.body != null){
            let dto = message.body;
            //console.log(message.body);
            if(dto.storeId == this.storeId && dto.accountId != this.userInfo.id){
                
                if((this.$router.currentRoute.path == "/planning/roster" && this.rosterView) || this.$router.currentRoute.path == "/preferences/preferenceview"){
                    if(dto.operation == 1){
                        //create or update
                        let map = this.planShiftMap;
                        let changed = false;
                        let rosterFrom = this.$helpers.getMomentFromStringTZ(this.rosterFromTo.from);
                        let rosterTo = this.$helpers.getMomentFromStringTZ(this.rosterFromTo.to);
                        dto.shifts.forEach(shift => {
                            let shiftFrom = this.$helpers.getMomentFromStringTZ(shift.from);
                            let shiftTo = this.$helpers.getMomentFromStringTZ(shift.to);
                            if(shiftFrom < rosterTo && shiftTo > rosterFrom){
                                if(!map[shift.id]){
                                    map[shift.id] = shift;
                                    changed = true;
                                } else {
                                    let oldShift = map[shift.id];
                                    let updateDate = oldShift.updatedAt ? this.$helpers.getMomentFromStringTZ(oldShift.updatedAt, "YYYY-MM-DDTHH:mm:ss.SSSSSSZ") : null;
                                    let newDate = shift.updatedAt ? this.$helpers.getMomentFromStringTZ(shift.updatedAt, "YYYY-MM-DDTHH:mm:ss.SSSSSSZ") : null;
                                    if(updateDate == null || (newDate != null && newDate > updateDate)){
                                        map[shift.id] = shift;
                                        changed = true;
                                    }
                                }
                            }
                        })
                        if(changed){
                            this.$store.commit('setPlanShiftMap', {
                                planShiftMap: map
                            });
                            this.$helpers.info(this.$t('shift.plan.info'), 'Dienstplan wurde von '+dto.name+" verändert!");
                        }
                        this.$store.commit("invalidateState", {states: ['planShiftMapState']});
                    } else if(dto.operation == 2){
                        //delete
                        let map = this.planShiftMap;
                        let changed = false;
                        dto.shifts.forEach(shift => {
                            if(map[shift.id]){
                                delete map[shift.id];
                                changed = true;
                            }
                        })
                        if(changed){
                            this.$store.commit('setPlanShiftMap', {
                                planShiftMap: map
                            });
                            this.$helpers.info(this.$t('shift.plan.info'), 'Dienstplan wurde von '+dto.name+" verändert!");
                        }
                        this.$store.commit("invalidateState", {states: ['planShiftMapState']});
                    } else if(dto.operation == 3 || dto.operation == 4){
                        this.$store.commit("invalidateState", {states: ['planShiftMapState', 'shiftTemplateState']});
                        this.$helpers.info(this.$t('shift.plan.info'), 'Schichtplan wurde von '+dto.name+" verändert!");
                    } else if(dto.operation == 5){
                        //create or update
                        
                        let map = this.employeePreferenceMap;
                        let changed = false;
                        let rosterFrom = this.$helpers.getMomentFromStringTZ(this.rosterFromTo.from);
                        let rosterTo = this.$helpers.getMomentFromStringTZ(this.rosterFromTo.to);
                        dto.preferences.forEach(pref => {
                            let prefFrom = this.$helpers.getMomentFromStringTZ(pref.from);
                            let prefTo = this.$helpers.getMomentFromStringTZ(pref.to);
                            if(prefFrom < rosterTo && prefTo > rosterFrom){
                                if(!map[pref.id]){
                                    map[pref.id] = pref;
                                    changed = true;
                                } else {
                                    let oldPref = map[pref.id];
                                    let updateDate = oldPref.updatedAt ? this.$helpers.getMomentFromStringTZ(oldPref.updatedAt, "YYYY-MM-DDTHH:mm:ss.SSSSSSZ") : null;
                                    let newDate = pref.updatedAt ? this.$helpers.getMomentFromStringTZ(pref.updatedAt, "YYYY-MM-DDTHH:mm:ss.SSSSSSZ") : null;
                                    if(updateDate == null || (newDate != null && newDate > updateDate)){
                                        map[pref.id] = pref;
                                        changed = true;
                                    }
                                }
                            }
                        })
                        if(changed){
                            this.$store.commit('setEmployeePreferenceMap', {
                                employeePreferenceMap: map
                            });
                            this.$helpers.info(this.$t('shift.plan.info'), 'Abwesenheiten wurden von '+dto.name+" verändert!");
                        }
                    } else if(dto.operation == 6){
                        //delete
                        let map = this.employeePreferenceMap;
                        let changed = false;
                        dto.preferences.forEach(pref => {
                            if(map[pref.id]){
                                delete map[pref.id];
                                changed = true;
                            }
                        })
                        if(changed){
                            this.$store.commit('setEmployeePreferenceMap', {
                                employeePreferenceMap: map
                            });
                            this.$helpers.info(this.$t('shift.plan.info'), 'Abwesenheiten wurden von '+dto.name+" verändert!");
                        }
                    } else if(dto.operation == 7){
                        //create or update
                        let map = this.actualShiftMap;
                        let breakMap = this.actualBreakMap;
                        let changed = false;
                        let rosterFrom = this.$helpers.getMomentFromStringTZ(this.rosterFromTo.from);
                        let rosterTo = this.$helpers.getMomentFromStringTZ(this.rosterFromTo.to);
                        dto.actualShifts.forEach(shift => {
                            let shiftFrom = this.$helpers.getMomentFromStringTZ(shift.from);
                            let shiftTo = this.$helpers.getMomentFromStringTZ(shift.to);
                            if(shiftFrom < rosterTo && shiftTo > rosterFrom){
                                if(!map[shift.id]){
                                    map[shift.id] = shift;
                                    changed = true;
                                } else {
                                    let oldShift = map[shift.id];
                                    let updateDate = oldShift.updatedAt ? this.$helpers.getMomentFromStringTZ(oldShift.updatedAt, "YYYY-MM-DDTHH:mm:ss.SSSSSSZ") : null;
                                    let newDate = shift.updatedAt ? this.$helpers.getMomentFromStringTZ(shift.updatedAt, "YYYY-MM-DDTHH:mm:ss.SSSSSSZ") : null;
                                    if(updateDate == null || (newDate != null && newDate > updateDate)){
                                        map[shift.id] = shift;
                                        changed = true;
                                    }
                                }
                            }
                        })
                        dto.actualBreaks.forEach(brk => {
                            let brkFrom = this.$helpers.getMomentFromStringTZ(brk.from);
                            let brkTo = this.$helpers.getMomentFromStringTZ(brk.to);
                            if(brkFrom < rosterTo && brkTo > rosterFrom){
                                if(!breakMap[brk.id]){
                                    breakMap[brk.id] = brk;
                                    changed = true;
                                } else {
                                    let oldShift = breakMap[brk.id];
                                    let updateDate = oldShift.updatedAt ? this.$helpers.getMomentFromStringTZ(oldShift.updatedAt, "YYYY-MM-DDTHH:mm:ss.SSSSSSZ") : null;
                                    let newDate = brk.updatedAt ? this.$helpers.getMomentFromStringTZ(brk.updatedAt, "YYYY-MM-DDTHH:mm:ss.SSSSSSZ") : null;
                                    if(updateDate == null || (newDate != null && newDate > updateDate)){
                                        breakMap[brk.id] = brk;
                                        changed = true;
                                    }
                                }
                            }
                        })
                        if(changed){
                            this.$store.commit('setActualBreakMap', {
                                actualBreakMap: breakMap
                            });
                            this.$store.commit('setActualShiftMap', {
                                actualShiftMap: map
                            });
                            this.$helpers.info(this.$t('shift.plan.info'), 'Stempelzeiten wurden aktualisiert!');
                        }
                        this.$store.commit("invalidateState", {states: ['actualShiftMapState', 'actualBreakMapState']});
                    } else if(dto.operation == 8){
                        //delete
                        let map = this.actualShiftMap;
                        let breakMap = this.actualBreakMap;
                        let changed = false;
                        dto.actualShifts.forEach(shift => {
                            if(map[shift.id]){
                                delete map[shift.id];
                                changed = true;
                                Object.values(this.actualBreakMap).forEach(brk => {
                                    if(brk.shiftId == shift.id){
                                        delete breakMap[brk.id]
                                    }
                                })
                                
                            }
                        })
                        dto.actualBreaks.forEach(brk => {
                            if(breakMap[brk.id]){
                                delete breakMap[brk.id];
                                changed = true;
                                
                                
                            }
                        })
                        if(changed){
                            this.$store.commit('setActualBreakMap', {
                                actualBreakMap: breakMap
                            });
                            this.$store.commit('setActualShiftMap', {
                                actualShiftMap: map
                            });
                            this.$helpers.info(this.$t('shift.plan.info'), 'Stempelzeiten wurden aktualisiert!');
                        }
                        this.$store.commit("invalidateState", {states: ['actualShiftMapState', 'actualBreakMapState']});
                    }
                } else {
                    //if we arent currently in the roster we will just invalidate the map state so that it is reloaded
                    if(dto.operation == 1 || dto.operation == 2){
                        this.$store.commit("invalidateState", {states: ['planShiftMapState']});
                        this.$helpers.info(this.$t('shift.plan.info'), 'Dienstplan wurde von '+dto.name+" verändert!");
                    }
                    if(dto.operation == 3 || dto.operation == 4){
                        this.$store.commit("invalidateState", {states: ['planShiftMapState', 'shiftTemplateState']});
                        this.$helpers.info(this.$t('shift.plan.info'), 'Schichtplan wurde von '+dto.name+" verändert!");
                    }
                    if(dto.operation == 5 || dto.operation == 6){
                        this.$store.commit("invalidateState", {states: ['employeePreferenceMapState']});
                        this.$helpers.info(this.$t('shift.plan.info'), 'Abwesenheiten wurden von '+dto.name+" verändert!");
                    }
                    if(dto.operation == 7 || dto.operation == 8){
                        this.$store.commit("invalidateState", {states: ['actualShiftMapState', 'actualBreakMapState']});
                        this.$helpers.info(this.$t('shift.plan.info'), 'Stempelzeiten wurden von verändert!');
                    }
                    
                }
                
            }        
        } else if(error != null){
            console.log(JSON.stringify(error));
        }
    },
    pingUserInfo(){
        let view = this;
        let token = view.$store.state.jwt;
        let storeId = Number(this.storeId);
        let headers = { token: token, storeId: storeId};
        let msg = {type: "userping", name: this.userFullname, imgUrl: this.imgUrl};
        let address = "ebin-storeevent:"+storeId;
        try {
            this.eventBus.send(address, msg, headers);
            this.timerId = window.setTimeout(view.pingUserInfo, 30000);
        } catch (error){
            console.log(error);
        }
    },
    sendChatMessage(chatmessage){
        let view = this;
        let token = view.$store.state.jwt;
        let storeId = Number(this.storeId);
        let headers = { token: token, storeId: storeId};
        let msg = {type: "chatmessage", name: this.userFullname, msg: chatmessage.msg, imgUrl: this.imgUrl};
        let address = "ebin-storeevent:"+storeId;
        try {
            this.eventBus.send(address, msg, headers);
            chatmessage.resolve();
        } catch (error){
            chatmessage.reject(error);
        }
    },
    cleanActiveStoreUsersMap(){
        let view = this;
        let now = this.$helpers.getMomentTZ();
        let toDelete = [];
        Object.values(this.activeStoreUsersMap).forEach(entry => {
            let dateMoment = this.$helpers.getMomentFromStringTZ(entry.date);
            if(now.diff(dateMoment, 'minutes') > 3){
                toDelete.push({mapName: "activeStoreUsersMap", id: entry.id});
            }
        });
        if(toDelete.length > 0){
            this.$store.commit("deleteMultiple", toDelete);
        }
        //console.log(JSON.stringify(this.activeStoreUsersMap));
        this.userMapCleanerTimer = window.setTimeout(view.cleanActiveStoreUsersMap, 60000);
    }

    


  }

}
</script>

<style scoped>

</style>
